import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';

export default class NoScroll extends Default {
  constructor() {
    super();
  }

  afterShow() {
    this._isActive = true;
    document.body.classList.add("__noScroll");
  }

  afterHide() {
    super.afterHide();
    document.body.classList.remove("__noScroll");
  }
}

ControllerPage._addPage('no-scroll', NoScroll);
